<app-navigation></app-navigation>
<main id="main">
  <div class="skiptarget visually-hidden">
    <a id="maincontent" tabindex="-1">-</a>
  </div>
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
